import { useT } from "@/i18n/LanguageContext";
import { Globe } from "lucide-react";

export const LanguageToggle = ({ className = "" }) => {
  const { lang, setLang } = useT();
  return (
    <div
      data-testid="lang-toggle"
      className={`inline-flex items-center gap-1 border border-white/15 rounded-full p-1 text-xs font-display font-bold ${className}`}
    >
      <Globe size={12} className="ml-2 text-zinc-400" />
      <button
        data-testid="lang-toggle-de"
        onClick={() => setLang("de")}
        className={`px-2 py-1 rounded-full transition-colors ${
          lang === "de" ? "bg-[#FFCC51] text-black" : "text-zinc-400 hover:text-white"
        }`}
      >
        DE
      </button>
      <button
        data-testid="lang-toggle-en"
        onClick={() => setLang("en")}
        className={`px-2 py-1 rounded-full transition-colors ${
          lang === "en" ? "bg-[#FFCC51] text-black" : "text-zinc-400 hover:text-white"
        }`}
      >
        EN
      </button>
    </div>
  );
};
